import type { SVGProps } from "react";
import type { JSX } from "react/jsx-runtime";

const ResetIcon = (
	props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>,
) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
		<title>Reset</title>
		<path d="M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z" />
	</svg>
);
export { ResetIcon };
